import { render } from "./DealsForm.vue?vue&type=template&id=6657accb"
import script from "./DealsForm.vue?vue&type=script&lang=js"
export * from "./DealsForm.vue?vue&type=script&lang=js"

import "./DealsForm.vue?vue&type=style&index=0&id=6657accb&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__